import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

// Anon key and URL are public — safe to embed. Env vars override in local dev.
const url =
  import.meta.env.VITE_SUPABASE_URL ??
  'https://qkghqmwcjpvbjlwyaujg.supabase.co';

const anonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ??
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrZ2hxbXdjanB2Ympsd3lhdWpnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk4MDQ3NTgsImV4cCI6MjA5NTM4MDc1OH0.wss0tt3c8SBMHjhVZMONfRJ6G3iPt_36E27C2rxsIig';

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type SupabaseClient = typeof supabase;
